import React, { useContext } from "react";
import { BreakpointContext, withStyles } from "components/common";
import teslaCar from "images/boost/tesla.svg";
import avatar1 from "images/boost/pricing_avatar_bob.svg";
import avatar2 from "images/boost/pricing_avatar_alice.svg";

const CAR_HEIGHT_MOBILE = 92;
const CAR_HEIGHT_DESKTOP = 196;
const CARD_PLACEMENT_MOBILE = -55;
const CARD_PLACEMENT_DESKTOP = -80;
const AVATAR_HEIGHT_MOBILE = 104;
const AVATAR_HEIGHT_DESKTOP = 140;
const AVATAR_PLACEMENT_MOBILE = -32;
const AVATAR_PLACEMENT_DEKSTOP = -80;

const CreditImpactView = () => {
  const { isBelow } = useContext(BreakpointContext);
  return (
    <div className="flex flex-col">
      {/* <h1
        className="text-4xl"
        style={{
          background: `linear-gradient(110deg, #E3DBFD 7.98%, #7F6AC0 116.99%)`,
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        The impact of good credit
      </h1>
      <p className="text-white text-justify mt-6">
        Your credit score impacts everyday essentials like housing, car loans,
        credit cards, and in some states, even securing jobs. By improving your
        credit score, you have the potential of saving tens of thousands, even
        hundreds of thousands of dollars in mortgage, auto, credit card and
        personal loan interest payments.{" "}
        <a
          href="https://www.lendingtree.com/personal/study-raising-credit-score-saves-money/"
          className="underline"
        >
          LendingTree found that borrowers that improved their credit from fair
          (580 to 669) to very good (740 to 799) could save $22,263 over the
          course of their lifetime.
        </a>
      </p>
      <p className="text-white text-justify mt-4 rounded-xl">
        In the example below, Cindy would save almost $7k on a car loan,
        compared to John with his lower credit score.
      </p> */}
      <div
        className="relative mt-24 lg:mt-40 flex flex-col p-4 lg:p-10 max-w-[920px] self-center rounded-lg"
        style={{
          background: " rgba(255, 255, 255, 0.08)",
        }}
      >
        <img
          src={teslaCar}
          alt="car"
          className=" absolute self-center"
          style={{
            height: isBelow("lg") ? CAR_HEIGHT_MOBILE : CAR_HEIGHT_DESKTOP,
            position: "absolute",
            top: isBelow("lg") ? CARD_PLACEMENT_MOBILE : CARD_PLACEMENT_DESKTOP,
          }}
        />
        <p
          className="text-white mb-2 self-center text-center"
          style={{
            fontSize: 28,
            marginTop:
              16 +
              (isBelow("lg")
                ? CAR_HEIGHT_MOBILE + CARD_PLACEMENT_MOBILE
                : CAR_HEIGHT_DESKTOP + CARD_PLACEMENT_DESKTOP),
          }}
        >
          <span className="font-bold">$37,490 </span>
          Tesla Model 3 <br />
          60-month loan term
        </p>
        <div className="flex flex-row flex-wrap justify-center items-center gap-10 mt-16 lg:mt-10">
          <div
            className="p-6 rounded-xl flex-1 min-w-[318px] max-w-[400px] relative"
            style={{
              background: " rgba(255, 255, 255, 0.08)",
            }}
          >
            <img
              src={avatar1}
              alt="avatar"
              style={{
                height: isBelow("lg")
                  ? AVATAR_HEIGHT_MOBILE
                  : AVATAR_HEIGHT_DESKTOP,
                borderRadius: "50%",
                position: "absolute",
                left: 16,
                top: isBelow("lg")
                  ? AVATAR_PLACEMENT_MOBILE
                  : AVATAR_PLACEMENT_DEKSTOP,
              }}
            />
            <h2 className="font-bold text-3xl text-white text-right">John</h2>
            <div className="mt-8 flex flex-col space-y-4 text-white font-semibold">
              <div className="flex justify-between">
                <p>Credit Score</p>
                <p>550 🚨</p>
              </div>
              <div className="flex justify-between">
                <p>APR</p>
                <p>12.85%</p>
              </div>
              <div className="flex justify-between">
                <p>Monthly Payments:</p>
                <p>$850.14</p>
              </div>
              <div className="flex justify-between">
                <p>Total Payments:</p>
                <p className="text-warning-600">$51,008.20 🆘</p>
              </div>
            </div>
          </div>
          <div
            className="p-6 rounded-xl flex-1 min-w-[318px] max-w-[400px] relative"
            style={{
              background: " rgba(255, 255, 255, 0.08)",
            }}
          >
            <img
              src={avatar2}
              alt="avatar"
              style={{
                height: isBelow("lg")
                  ? AVATAR_HEIGHT_MOBILE
                  : AVATAR_HEIGHT_DESKTOP,
                borderRadius: "50%",
                position: "absolute",
                right: 16,
                top: isBelow("lg")
                  ? AVATAR_PLACEMENT_MOBILE
                  : AVATAR_PLACEMENT_DEKSTOP,
              }}
            />
            <h2 className="font-bold text-3xl text-white text-left">Cindy</h2>
            <div className="mt-8 flex flex-col space-y-4 text-white font-semibold">
              <div className="flex justify-between">
                <p>Credit Score</p>
                <p>750 🌟</p>
              </div>
              <div className="flex justify-between">
                <p>APR</p>
                <p>6.80%</p>
              </div>
              <div className="flex justify-between">
                <p>Monthly Payments:</p>
                <p>$738.81</p>
              </div>
              <div className="flex justify-between">
                <p>Total Payments:</p>
                <p className="text-success-500">$44,328.87 🎉</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CreditImpact = withStyles(CreditImpactView);
export default CreditImpact;
